import React from "react";
import { useRoles } from "../lib/useRoles";
import AdminDashboard from "./AdminDashboard";
import TechDashboard from "./TechDashboard";

export default function Dashboard() {
  const { isTech } = useRoles();
  return isTech ? <TechDashboard /> : <AdminDashboard />;
}